/* eslint-disable no-console */

import { register } from "register-service-worker";

export async function processarFilaProntuario() {
  if(!("serviceWorker" in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const worker = navigator.serviceWorker.controller || registration.active;

    if(!worker) {
      return;
    }

    worker.postMessage({ type: "PROCESS_PRONTUARIO_QUEUE" });
  } catch (error) {
    console.error("Erro ao solicitar processamento da fila:", error);
  }
}

if(process.env.NODE_ENV === "production" && !/^\/pagar\//.test(window.location.pathname)) {
  navigator.serviceWorker.addEventListener(
    "message",
    (event) => {
      document.dispatchEvent(
        new CustomEvent("serviceWorkerMessage", {
          detail: event.data
        })
      );
    }
  );

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      setInterval(() => {
        registration.update();
      }, 60000);
      window.addEventListener("online", () => {
        processarFilaProntuario();
      });
    },
    cached (registration) {
      console.log('Content has been cached for offline use.')
      document.dispatchEvent(
        new CustomEvent('swCached', { detail: registration })
      )
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
